import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './reportsArquivoForm';
import Aguardando from '../common/template/aguardando';

import { setModoTela, initForm, salvar, excluir, getLista, getDownload, getDownloadAll } from './reportsArquivoActions';
import DateFormat from '../common/dateFormat/DateFormat';

class ReportsArquivo extends Component {

	state = {
		linhaSelecionada: null
	}

    componentWillMount() {
		this.props.setModoTela('lista');
        this.props.getLista(this.props.shipping);
    }

	componentWillUnmount() {
		this.props.setModoTela('lista');
        this.props.getLista(0);
    }

    render() {
        return (
            <div>
                <Content>

					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	getIcon(type) {
		switch (type) {
			case "pdf":
				return "fa-file-pdf";
			case "doc":
			case "docx":
				return "fa-file-word";
			case "xls":
			case "xlsx":
				return "fa-file-excel";
			case "ppt":
			case "pptx":
				return "fa-file-powerpoint";
			case "png":
			case "jpg":
			case "jpeg":
				return "fa-file-image";
			case "txt":
				return "fa-file-lines";
			case "xml":
				return "fa-file-code";
			default:
				return "fa-file";
		}
	};

	lista() {
		return (
			<div>
					<Row>
						<a class={`btn btn-app bg-primary ${this.props.lista.length < 15 ? '' : 'disabled'}`} style={{ marginLeft: 8, minWidth: 75 }}
							onClick={() => {
								if (this.props.lista.length < 15) {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({
										shipping: this.props.shipping,
										solicitacao: this.props.solicitacao
									});
								}
							}}>
							<i class='fas fa-plus'></i> Adicionar
						</a>
						<a class='btn btn-app bg-success' style={{ marginLeft: 8, minWidth: 75 }}
							onClick={() => {
								this.props.getDownloadAll(this.props.shipping);
							}}>
							<i class='fas fa-download'></i> Todos
						</a>
					</Row>
					
					<ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
						{this.props.lista.map((item, index) => (
							<li
								key={index}
								style={{
									display: "flex",
									alignItems: "center",
									padding: "8px 12px",
									borderBottom: "1px solid #ddd",
									background: index % 2 === 0 ? "#f9f9f9" : "#fff"
								}}
							>
								<i
									className={`fas ${this.getIcon(item.extensao)}`}
									style={{ fontSize: 20, marginRight: 12, color: "#1F3066" }}
								></i>

								<div style={{ flex: 1 }}>
									<div style={{ fontWeight: 500 }}>{item.nome}</div>
									<div style={{ fontSize: 12, color: "#666" }}>{item.legenda}</div>
								</div>

								<div style={{ width: 250, textAlign: 'center', fontSize: 12 }}>{item.nome_usuario_inclusao}</div>
								
								<div style={{ width: 130, textAlign: 'center', fontSize: 12 }}>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_inclusao)}</div>
							
								<button
									onClick={() => {
										this.props.getDownload(item.id);
									}}
									style={{
										border: 'none',
										background: 'transparent',
										cursor: 'pointer',
										fontSize: 16,
										marginLeft: 4
									}} >
									<i className='fas fa-download'></i>
								</button>

								{item.id_usuario_inclusao == this.props.sessao.id &&
								<button
									style={{
										border: 'none',
										background: 'transparent',
										color: 'red',
										cursor: 'pointer',
										fontSize: 16,
										marginLeft: 4
									}}
									title={'Remover'}
									onClick={() => {
										if (window.confirm('Deseja realmente remover?')) {
											this.props.excluir(item);
										}
									}} >
									<i className='fas fa-trash'></i>
								</button>}
							</li>
						))}
					</ul>
			</div>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.reportsArquivo.modoTela,
	aguardando: state.reportsArquivo.aguardando,
	lista: state.reportsArquivo.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm, salvar, excluir, getLista, getDownload, getDownloadAll }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ReportsArquivo);
